@if (visible()) {
  @let state = batchUploadService.state();
  <div
    class="fixed bottom-4 right-4 z-50 w-80 rounded-lg border border-gray-200 bg-white p-4 shadow-xl"
    role="status"
    aria-live="polite"
  >
    <div class="mb-2 flex items-center gap-2">
      <i class="pi pi-cloud-upload text-primary-500"></i>
      <span class="font-medium text-gray-800">
        {{ "calculator.uploadInProgress" | transloco }}
      </span>
    </div>

    @if (state.status === "uploading") {
      <p-progressBar [value]="percent()" [showValue]="false" />
      <p class="mt-1 text-xs text-gray-500">
        {{ state.uploaded }} / {{ state.total }}
      </p>
    } @else {
      <p-progressBar mode="indeterminate" [style]="{ height: '6px' }" />
    }

    <p class="mt-2 text-xs text-gray-500">
      {{ "calculator.uploadInProgressMessage" | transloco }}
    </p>
  </div>
}
